import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { LinearProgress } from '@mui/material';
import { useSelector } from 'react-redux';

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  background-color: rgba(255, 255, 255, 0.7);
`;

const Text = styled.span`
  font-size: 1.25rem;
`;

const ProgressBar = styled.div`
  width: 200px;
  margin: 10px 0;
`;

const BasicLoading = ({ progress }) => {
  const intl = useIntl();
  const loading = useSelector((state) => state.loading);

  if (!loading.open) {
    return null;
  }

  return (
    <Root>
      <Text>{`${intl.formatMessage({ id: 'loading' })} ${progress ? `${parseInt(progress)}%` : '...'}`}</Text>
      <ProgressBar>
        {progress ? (
          <LinearProgress color="inherit" variant="determinate" value={progress} />
        ) : (
          <LinearProgress color="inherit" />
        )}
      </ProgressBar>
    </Root>
  );
};

export default BasicLoading;
